import { render, staticRenderFns } from "./DeliveryWaitingListModal.vue?vue&type=template&id=2f69054a&"
import script from "./DeliveryWaitingListModal.vue?vue&type=script&lang=js&"
export * from "./DeliveryWaitingListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports